/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const BrazeIcon = ({
  className,
  style: styleFromProps,
  onClick,
  color = '#752DD3',
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={className}
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="4" fill={color} />
      <g clipPath="url(#clip0_8352_15474)">
        <path
          d="M20.8436 23.7455C21.04 21.8691 22.2182 20.3418 23.5927 20.3418C24.9673 20.3418 25.7091 21.8691 25.5127 23.7455C25.3164 25.6218 24.1818 27.1709 22.8945 27.1709C21.6073 27.1709 20.56 25.9927 20.8436 23.7455ZM22 32.2545C18.9457 32.2589 16.049 30.8986 14.1018 28.5455C15.8036 29.0909 17.7018 28.6109 19.1855 27.1491C19.3421 26.9919 19.4879 26.8243 19.6218 26.6473C20.2982 28.1091 21.6073 28.8509 22.9164 28.8509C25.1418 28.8509 27.0182 26.56 27.2364 23.7236C27.4545 20.8873 25.8618 18.64 23.7455 18.64C22.9775 18.6294 22.2219 18.8334 21.5636 19.2291L22.2182 15.4109C22.2834 15.1053 22.2117 14.7864 22.0218 14.5382C21.8255 14.2327 21.6509 14.1018 21.3891 14.1018H18.3345C18.154 14.1112 18.0065 14.2495 17.9855 14.4291C17.9043 14.7887 17.846 15.153 17.8109 15.52C17.7891 15.76 17.9636 15.8473 18.16 15.8473H20.3855C20.0364 18.0291 19.3382 22.2618 19.1418 23.3309C18.936 24.3429 18.4437 25.2744 17.7236 26.0145C16.5018 27.2364 14.2545 27.52 12.9236 26.1891C12.4655 25.7091 11.7455 24.5309 11.7455 22C11.7455 16.3366 16.3366 11.7455 22 11.7455C27.6634 11.7455 32.2545 16.3366 32.2545 22C32.2545 27.6634 27.6634 32.2545 22 32.2545ZM22 10C15.3726 10 10 15.3726 10 22C10 28.6274 15.3726 34 22 34C28.6274 34 34 28.6274 34 22C34 18.8174 32.7357 15.7652 30.4853 13.5147C28.2348 11.2643 25.1826 10 22 10Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8352_15474">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
